import { Route, Switch } from "react-router-dom";
import Products from "../containers/Products/Index";
import Categories from "../containers/Categorias/Categories";
import IndexCategoriesAdmin from "../containers/Categorias/CategoriasAdmin/IndexCategoriasAdmin";
import IndexProductsAdmin from "../containers/Products/ProductsAdmin/IndexProductsAdmin";
import AyudaAdmin from "../containers/Ayuda/AyudaAdmin/IndexAyudaAdmin";
import OrdersAdmin from "../containers/Orders/OrdersAdmin/IndexOrdersAdmin";
import InicioAdmin from "../containers/Admin/InicioAdmin";
import Ayuda from "../containers/Ayuda/Ayuda";
import Directions from "../containers/Directions/Directions";
import EditarProduct from "../containers/Products/ProductsAdmin/EditarProduct";
import ShowOrder from "../containers/Control/ShowOrder";
import ProductsCategory from "../containers/Categorias/ProductsCategory";
import StoreProduct from "../containers/Products/ProductsAdmin/StoreProduct";
import IndexPedidos from "../containers/Pedidos/IndexPedidos";
import Brands from "../containers/Brands/Brands";
import ProductsBrand from "../containers/Brands/ProductsBrand";
import BrandsAdmin from "../containers/Brands/BrandsAdmin/Index";
import Discounts from "../containers/Discounts/Discounts";
import Information from "../containers/Admin/ContactInformation/Information";
import Account from "../containers/Account/Account";
import CompanyInformation from "../containers/Admin/ContactInformation/CompanyInformation";
import Policies from "../containers/Policies";
import Devoluciones from "../containers/Devoluciones";
import Points from "../containers/Points/Points";
import AddEntryProducts from "../containers/Products/EnterProducts/AddEntryProducts";
import ProfilePage from "../containers/Profile/Profile";
import SingleProductPage from "../containers/Products/ProductsShow";
import CartPage from "../containers/Cart/CartPage";
import CheckoutPage from "../containers/Checkout/CheckoutPage";
import PayOrderPage from "../containers/Checkout/PayOrderPage";
import DiscountsPage from "../containers/Discounts/Discounts";
import ContactPage from "../containers/Contact/ContactIndex";
import FaqPage from "../containers/Faq/Faq";
import DetailEntry from "../containers/Products/EnterProducts/DetailEntry";
import AddDepartureProducts from "../containers/Products/DepartureProducts/AddDepartureProducts";
import ShowDepartureProducts from "../containers/Products/DepartureProducts/ShowDepartureProducts";
import TermsAndConditionsPage from "../containers/TermsAndConditions/TermsAndConditionsPage";
import PoliciesPage from "../containers/Policies/PoliciesPage";
import PoliciesBackPage from "../containers/PoliciesBack/PoliciesBackPage";
import ContentPage from "../containers/Content/ContentPage";
import OrdersProfile from "../containers/Profile/OrdersProfile";
import DirectionsProfile from "../containers/Profile/DirectionsProfile";
import ComunityPage from "../containers/Comunity/ComunityPage";
import AdminRoute from "./AdminRoute";

export const EcommerceRoutes = () => {
  let component = Products;

  return (
    <Switch>
      {/**Rutas Admin - Protegidas */}
      <AdminRoute exact path='/admin' component={InicioAdmin} />
      <AdminRoute exact path='/inicio-admin' component={InicioAdmin} />
      <AdminRoute exact path='/Marcas-admin' component={BrandsAdmin} />
      <AdminRoute exact path='/categorias-admin' component={IndexCategoriesAdmin} />
      <AdminRoute exact path='/productos-admin' component={IndexProductsAdmin} />
      <AdminRoute exact path='/ayuda-admin' component={AyudaAdmin} />
      <AdminRoute exact path='/ventas-admin' component={OrdersAdmin} />
      <AdminRoute exact path='/Editar-producto/:id' component={EditarProduct} />
      <AdminRoute exact path='/Registrar-producto' component={StoreProduct} />
      <AdminRoute exact path='/informacion-Contacto' component={Information} />
      <AdminRoute exact path='/society' component={CompanyInformation} />
      <AdminRoute exact path='/Registrar-Entradas' component={AddEntryProducts} />
      <AdminRoute exact path='/nueva-salida' component={AddDepartureProducts} />
      <AdminRoute exact path='/DetalleSalida/:id' component={ShowDepartureProducts} />
      <AdminRoute exact path='/DetalleEntrada/:id' component={DetailEntry} />

      {/**Rutas Usuario */}
      <Route exact path='/' component={component} />
      <Route exact path='/categorias' component={Categories} />
      <Route exact path='/direcciones' component={Directions} />
      <Route exact path='/pedidos' component={IndexPedidos} />
      <Route exact path='/ayuda' component={Ayuda} />
      <Route exact path='/Carrito-compras' component={CartPage} />
      <Route exact path='/Detalle-venta/:id' component={ShowOrder} />
      <Route exact path='/Descuentos' component={Discounts} />
      <Route exact path='/producto/:id' component={SingleProductPage} />
      <Route
        exact
        path='/productos/:id/:category'
        component={ProductsCategory}
      />
      <Route exact path='/pagar-carrito' component={CheckoutPage} />
      <Route exact path='/pago-orden/:id' component={PayOrderPage} />
      <Route exact path='/Marcas' component={Brands} />
      <Route exact path='/productos/:name' component={ProductsBrand} />
      <Route exact path='/MiCuenta' component={Account} />
      <Route exact path='/puntos' component={Points} />
      <Route
        exact
        path='/Terminos-condiciones-MerryColor'
        component={Policies}
      />
      <Route
        exact
        path='/Terminos-condiciones-Reembolsos-Devoluciones-MerryColor'
        component={Devoluciones}
      />
      <Route exact path='/profile' component={ProfilePage} />
      <Route exact path='/profile/orders' component={OrdersProfile} />
      <Route exact path='/profile/directions' component={DirectionsProfile} />
      <Route exact path='/distribuidores-merry' component={DiscountsPage} />
      <Route exact path='/Contacto-Merry' component={ContactPage} />
      <Route exact path='/preguntas-frecuentes' component={FaqPage} />
      <Route
        exact
        path='/terminos-y-condiciones'
        component={TermsAndConditionsPage}
      />
      <Route exact path='/comunidad' component={ComunityPage} />
      <Route exact path='/politicas-privacidad' component={PoliciesPage} />
      <Route exact path='/politicas-devolucion' component={PoliciesBackPage} />
      <Route exact path='/contenido-merrycolor' component={ContentPage} />
    </Switch>
  );
};
